'use strict';

var React = require('react'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    { PropTypes } = React;

require('./BtnGroup.less');

var BtnGroup = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    vertical: PropTypes.bool,
    split: PropTypes.bool
  },

  className: 'BtnGroup',

  getDefaultProps: function () {
    return {
      vertical: false,
      split: false
    };
  },

  getCSSModifiers: function () {
    return [
      this.props.vertical && 'vertical',
      this.props.split && 'split'
    ];
  },

  render: function () {
    return (
      <div className={this.getClassName()}>
        {this.props.children}
      </div>
    );
  }
});

module.exports = BtnGroup;



/** WEBPACK FOOTER **
 ** ./molecules/BtnGroup.jsx
 **/